import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import { quizValidationSchema } from '../../utils/util';

const useStyles = makeStyles(() => {
  return {
    formControl: {
      marginBottom: 15,
    },
  };
});

const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: green[400],
    },
  },
  checked: {},
// eslint-disable-next-line react/jsx-props-no-spreading
})((props) => { return <Checkbox color="default" {...props} />; });

export default function Question(props) {
  const classes = useStyles();
  const getInitialState = (dataObj = {}) => {
    return {
      question: dataObj.question || '',
      options: dataObj.options || ['', ''],
      answerIndexes: dataObj.answerIndexes || [],
    };
  };
  const {
    quizObj, disabled, handleQuizesChange, setSnack,
  } = props;

  const [obj, setObj] = React.useState(getInitialState());

  const handleChange = (e, isOptionChange) => {
    const name = e.target.name;
    const value = e.target.value;
    const options = obj.options;
    if (isOptionChange) {
      options[parseInt(name, 10)] = value;
      setObj((prevObj) => {
        return { ...prevObj, options };
      });
    } else {
      setObj((prevObj) => {
        return { ...prevObj, [name]: value };
      });
    }
  };

  const handleIndexChange = (index) => {
    const answerIndexes = obj.answerIndexes;
    if (answerIndexes.includes(index)) {
      const i = answerIndexes.indexOf(index);
      answerIndexes.splice(i, 1);
    } else answerIndexes.push(index);
    setObj((prevObj) => {
      return { ...prevObj, answerIndexes };
    });
  };

  const addQuiz = () => {
    const options = obj.options.filter((option) => { return option; });
    const answerIndexes = obj.answerIndexes.filter((item) => { return item < options.length; });
    quizValidationSchema.validate({ ...obj, options, answerIndexes })
      .then(() => {
        return handleQuizesChange({ ...obj, options, answerIndexes });
      }).catch((err) => {
        setSnack({ open: true, severity: 'error', message: err.message || 'Something went wrong' });
      });
  };

  const addOption = () => {
    const options = obj.options;
    options.push('');
    setObj((prevObj) => { return { ...prevObj, options }; });
  };

  const removeOption = (index) => {
    const options = obj.options;
    options.splice(index, 1);
    const answerIndexes = obj.answerIndexes;
    if (answerIndexes.includes(index)) {
      const i = answerIndexes.indexOf(index);
      answerIndexes.splice(i, 1);
    }
    setObj((prevObj) => { return { ...prevObj, options, answerIndexes }; });
  };

  React.useEffect(() => {
    setObj(getInitialState({ ...quizObj }));
  }, [quizObj]);

  return (
    <div>
      <Grid>
        <Grid>
          <Typography component="span" className={classes.title}>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <TextField
                label="Question"
                name="question"
                value={obj.question}
                variant="outlined"
                onChange={handleChange}
                disabled={disabled || false}
              />
            </FormControl>
          </Typography>
        </Grid>
        <Grid>
          <FormControl fullWidth>
            {
                obj.options.map((option, index) => {
                  const isChecked = obj.answerIndexes.includes(index);
                  return (
                    <Grid
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      container
                    >
                      <Grid item xs={2} md={1} sm={2}>
                        <FormControlLabel
                          className={classes.formControl}
                          control={(
                            <GreenCheckbox
                              checked={isChecked}
                              onChange={() => { return (!disabled && handleIndexChange(index)); }}
                              name={index.toString()}
                              inputprops={disabled ? { readOnly: true } : {}}
                            />
                            )}
                        />
                      </Grid>
                      <Grid container item xs={10} md={11} sm={10}>
                        <Grid item xs={10} md={11} sm={10}>
                          <FormControl fullWidth variant="outlined" className={classes.formControl}>
                            <TextField
                              label={`Option ${index + 1}`}
                              name={`${index}`}
                              value={option}
                              variant="outlined"
                              size="small"
                              onChange={(e) => { handleChange(e, true); }}
                              disabled={disabled || false}
                            />
                          </FormControl>
                        </Grid>
                        {
                          !disabled
                            ? (
                              <Grid item xs={2} md={1} sm={2} container justify="flex-end" className={classes.formControl}>
                                <IconButton size="small" onClick={() => { removeOption(index); }}><DeleteIcon fontSize="small" /></IconButton>
                              </Grid>
                            ) : null
                        }
                      </Grid>
                    </Grid>
                  );
                })
            }
            {
              !disabled
                ? (
                  <Grid container justify="flex-end">
                    <Button size="small" variant="contained" onClick={addOption} startIcon={<AddIcon />}>Option</Button>
                  </Grid>
                ) : null
            }
          </FormControl>
        </Grid>
        <Grid container justify="center">
          {
            !disabled ? <Button variant="contained" color="primary" onClick={addQuiz}><b>Add</b></Button> : null
          }
        </Grid>
      </Grid>
    </div>
  );
}
